export const TIERS = ['member', 'blue', 'gold', 'platinum']

const bestPriceGuarantee = `Or we'll refund the difference`
export const ROWS = [
  {
    name: 'header',
    label: '',
    member: 'Sign Up',
    blue: '2 completed trips*',
    gold: '5 completed trips* or Priceline Rewards™ Visa® Card holder',
    platinum: '25 completed trips*',
  },
  {
    name: 'bestPriceGuarantee',
    label: 'Our Best Price Guarantee',
    labelLink: {
      text: 'Learn more',
      href: 'https://help.priceline.com/what-is-best-price-guarantee-Sys6cJ86u',
    },
    member: bestPriceGuarantee,
    blue: bestPriceGuarantee,
    gold: bestPriceGuarantee,
    platinum: bestPriceGuarantee,
  },
  {
    name: 'exclusiveHotelSavings',
    label: 'Exclusive Hotel Savings',
    member: 'Up to 10%',
    blue: 'Up to 50% on over 15,000 hotels',
    gold: 'Up to 50% on over 30,000 hotels',
    platinum: 'Up to 50% on over 45,000 hotels',
  },
  {
    name: 'rentalCarDiscounts',
    label: 'VIP Rental Car Discounts',
    member: 'Up to 10%',
    blue: 'Up to 15%',
    gold: 'Up to 20%',
    platinum: 'Up to 20%',
  },
  {
    name: 'addOnDeals',
    label: 'Add-On Deals',
    member: 'Up to 50% on hotels and 20% on rental cars when adding to an existing trip',
    blue: 'Up to 50% on hotels and 20% on rental cars when adding to an existing trip',
    gold: 'Up to 50% on hotels and 20% on rental cars when adding to an existing trip',
    platinum: 'Up to 50% on hotels and 20% on rental cars when adding to an existing trip',
  },
  {
    name: 'insiderCoupons',
    label: 'Insider Coupons',
    member: '5% Express Deal coupon after every trip',
    blue: '5% Express Deal coupon after every trip',
    gold: '8% Express Deal coupon after every trip',
    platinum: '10% Express Deal coupon after every trip',
  },
  {
    name: 'premiumCustomerService',
    label: 'Premium Customer Service',
    member: '',
    blue: '',
    gold: 'Priority',
    platinum: 'First Priority',
  },
]

export const FASTLY_CROPS = {
  HERO_LGXXL: `opto&optimize=medium&auto=jpg&trim=0,780,290,0&fit=crop`,
  HERO_MOBILE: `opto&optimize=medium&auto=jpg&trim=160,1140,360,460&width=800&height=800&fit=bounds`,
  HERO_MOBILE_2x: `opto&optimize=medium&auto=jpg&trim=160,1140,360,460&width=800&height=800&fit=bounds&dpr=2`,
}
export const PROPVALUE = [
  {
    id: 1,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/couple-friends-excited-airport-terminal.jpg?opto&width=256&crop=1:1,smart',
    imageAlt: 'Hilarious smiling couple playing at terminal',
    headLine: `Become a member for FREE!\nNo strings attached.`,
  },
  {
    id: 2,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/getaways-waterfront-mountain-cottage.jpg?opto&width=256&crop=1:1,smart',
    imageAlt: 'Beautiful house on a hill overlooking water. Inspirational place to stay on vacations',
    headLine: 'Always get our Best Price.\nGuaranteed.',
  },
  {
    id: 3,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/friends-smiling-group-selfie.jpg?opto&width=256&crop=1:1,smart',
    imageAlt:
      'Happy friends from diverse cultures and races taking selfie with back lighting - Youth and friendship concept with young people having fun together',
    headLine: 'Unlock exclusive VIP discounts and coupons.',
  },
]

export const ZIGZAG = [
  {
    id: 1,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/friends-cheering-mountain-top.jpg?opto&width=600&crop=1:1,smart',
    imageAlt:
      'Big group of people having fun in success pose with raised arms on mountain top against sunset lakes and mountains. Travel, adventure or expedition concept',
    iconName: 'verified',
    iconText: 'Best Price.\nGuaranteed.',
    headLine: 'Your short-cut to\nsavings.',
    subHeadLine:
      "You'll automatically get our best price guarantee so you can spend less time searching for deals and more time traveling.",
    button: 'Sign Up',
  },
  {
    id: 2,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/friends-underwater-pool-selfie.jpg?opto&width=600&crop=1:1,smart',
    imageAlt: 'Young couple smiling under water',
    iconName: 'hotels',
    iconText: 'Travel like\na VIP',
    headLine: 'Get the service you\ndeserve.',
    subHeadLine:
      "From early access to sales to priority customer service, you'll always be our top priority.",
    button: 'Get Started',
  },
  {
    id: 3,
    imageSrc:
      'https://s1.pclncdn.com/design-assets/vip/roadtrip-shoes-car-dashboard.jpg?opto&width=600&crop=1:1,smart',
    imageAlt:
      'Female legs in ripped jeans and blue sneakers inside car with mountains landscape at background. Woman relaxing during road trip',
    iconName: 'cars',
    iconText: 'Hotel and Rental\nCar Discounts',
    headLine: 'Travel large, spend small. Save big on every trip you take.',
    subHeadLine: 'Get even better deals on thousands of hotels and rental cars!',
    button: 'Start Saving!',
  },
]

export const APP_DOWNLOAD_CONTENT = {
  gaAction: 'app download',
  smallHeadingText: 'savings on the go',
  headingText: 'Tonight Only Deals. Only in the App.',
  contentText:
    'Discover hotel, flight and rental car deals exclusively in the app. Download today to stay connected with important trip details \u2014 anytime, anywhere.',
  image: 'https://s1.pclncdn.com/design-assets/brand-assets/Priceline-App-devices.jpg',
  imageWebP: 'https://s1.pclncdn.com/design-assets/brand-assets/Priceline-App-devices.webp',
  imageSize: '307px 383px',
  buttons: [
    {
      gaLabel: 'Android',
      linkUrl: 'https://www.priceline.com/mobile-app/',
    },
    {
      gaLabel: 'iOS',
      linkUrl: 'https://www.priceline.com/mobile-app/',
    },
  ],
}
